<header class="header">
    <div class="menubox">
        <button mat-mini-fab class="btnmenu" (click)="exampleSidenav.toggle();isToggleOpen = !isToggleOpen;">
            <i class="btntext icon-menu-o"></i>
        </button>
        <button mat-mini-fab class="btnmenu" (click)="callWaiters()"
            *ngIf="headerGarsonCall && hideNotification === false">
            <i class="icon-notifications_active-F btntext"></i>
        </button>
        <div class="garson">
            <span class="garsonname">{{this.share.loginuser ? this.share.loginuser.name : ''}}</span>
        </div>
    </div>
    <div *ngIf="hasLogo">
        <img class="logo" src="../../assets/imgs/logo.png" title="logo" alt="logo" />
    </div>
    <div class="menubox" [class.refresh]="hasRefresh">
        <button mat-mini-fab class="btnmenu" (click)="go('ordermanagement')"
            *ngIf="hasnotification && share.setting?.systemLayer?.hasDigitalMenu">
            <span [matBadge]="share.digitalmenuFactorCount" matBadgePosition="below" matBadgeSize="small"
                matBadgeColor="primary"></span>
            <i class="icon-notifications-F btntext icon"></i>
        </button>

        <button mat-mini-fab class="btnmenu" (click)="refresh()" *ngIf="hasRefresh">
            <i class="icon-refresh-o btntext icon"></i>
        </button>
        <button *ngIf="!share.setting.digitalMenuSingleThem" mat-mini-fab [matMenuTriggerFor]="thememenu"
            class="btnmenu" [disabled]="share.setting.digitalMenuSingleThem">
            <i class="icon icon-color_lens-o icon btntext"></i>
        </button>
        <mat-menu #thememenu="matMenu">
            <div class="themebox">
                <div (click)="share.setTheme('blue')" class="blue theme"></div>
                <div (click)="share.setTheme('orange')" class="orange theme"></div>
                <div (click)="share.setTheme('light')" class="light theme"></div>
                <div (click)="share.setTheme('dark')" class="dark theme"></div>
            </div>
        </mat-menu>

        <button mat-mini-fab [matMenuTriggerFor]="lanmenu" class="btnmenu" disabled="false">
            <span class="btnlan">{{share.sharemodel.language}}</span>
        </button>
        <mat-menu #lanmenu="matMenu">
            <button mat-menu-item (click)="setLanguage('EN')">English</button>
            <button mat-menu-item (click)="setLanguage('FA')">Persian</button>
        </mat-menu>
    </div>
</header>
<div class="cover" [class.show]="isToggleOpen" (click)="exampleSidenav.close();isToggleOpen = !isToggleOpen;">
    <mat-sidenav #exampleSidenav class="example-sidenav mat-elevation-z3 rightmenu" [mode]="'over'">
        <mat-toolbar>
            SEPIDZ
            <span fxFlex></span>
            <div class="btnbox">
                <i class="icon-keyboard_arrow_right-o keyboardarrow sideicon"></i>
            </div>
        </mat-toolbar>
        <mat-nav-list class="nav-list">
            <button class="list-btn" mat-button *ngIf="share.lastUrl !=='order/TableId/'
      && share.lastUrl !== 'club' && share.lastUrl !== 'payment'
      && share.setting && share.setting.systemLayer.hasDigitalMenu &&
      share.lastUrl !=='/table'&& share.lastUrl !=='table'
      && !share.loginuser
      && share.lastUrl !=='/waiterorder'  && share.lastUrl !=='/waiterorder'  && share.lastUrl !=='/ordermanagement'"
                (click)="exampleSidenav.close();go('order/TableId/')">
                <i class="icon-local_dining-o sideicon localdining"></i>
                <span class="text">{{'Public.Order' | translate}} </span>
            </button>
            <mat-divider></mat-divider>

            <button class="list-btn" mat-button
                *ngIf="share.lastUrl !== '/ordermanagement'&& share.lastUrl !== '/finalfactor'
      && share.lastUrl !== '/about' && share.lastUrl !== 'club' && share.lastUrl !== 'payment'
      && share.lastUrl !== '/game' && share.lastUrl !=='order/TableId/' && share.setting && share.setting?.systemLayer?.hasDigitalMenu && !this.share.setting?.systemLayer?.isDigitalAlbum "
                (click)="isToggleOpen = !isToggleOpen;exampleSidenav.close();go('ordermanagement')">
                <i class="icon-library_books-o sideicon librarybooks"></i>
                <span class="text">{{'Labels.OrderManagement' | translate}}</span>
            </button>
            <mat-divider></mat-divider>

            <button class="list-btn" mat-button
                *ngIf="share.lastUrl !== '/waiterorder'
      && share.lastUrl !== '/finalfactor'
      && share.lastUrl !== 'club' && share.lastUrl !== 'payment' && share.lastUrl !== '/about' && share.lastUrl !== '/game' && share.lastUrl !=='order/TableId/' && share.setting && share.lastUrl !== '/table' && share.setting && share.setting?.systemLayer?.hasTabletOrder"
                (click)="isToggleOpen = !isToggleOpen;exampleSidenav.close();  go('waiterorder')">
                <i class="icon-people_alt-o sideicon people"></i>
                <span class="text">{{'Labels.WaiterOrder' | translate}}</span>
            </button>
            <mat-divider></mat-divider>

            <button class="list-btn" mat-button *ngIf="
       share.lastUrl !== 'club' && share.lastUrl !== 'payment'&& share.lastUrl !== '/game'
      &&  share.lastUrl === '/about' || share.lastUrl ==='order/TableId/' "
                (click)="isToggleOpen = !isToggleOpen;exampleSidenav.close();  go('game')">
                <i class="icon-emoticon-happy-outline sideicon Game"></i>
                <span class="text">{{'Labels.Game' | translate}}</span>
            </button>
            <mat-divider></mat-divider>

            <button class="list-btn" mat-button *ngIf="sidemenuGarsonCall && hideNotification === false"
                (click)="isToggleOpen = !isToggleOpen;exampleSidenav.close();  callWaiters();">
                <i class="icon-notifications_none-F sideicon callWaiters"></i>
                <span class="text">{{ "MainPage.GarsonCall" | translate }} </span>
            </button>
            <mat-divider></mat-divider>

            <button class="list-btn" mat-button *ngIf="share.lastUrl !== '/about' && share.lastUrl !== 'club' && share.lastUrl !== 'payment'
      &&  share.lastUrl === '/game' || share.lastUrl ==='order/TableId/' "
                (click)="isToggleOpen = !isToggleOpen;exampleSidenav.close();  go('about')">
                <i class="icon-info-24px sideicon info"></i>
                <span class="text">{{'Labels.AboutUs' | translate}}</span>
            </button>
            <mat-divider></mat-divider>
            <button class="list-btn" mat-button
                *ngIf="share.lastUrl !== '/login'
            && share.lastUrl !== '/finalfactor'&& share.lastUrl !== 'club' && share.lastUrl !== 'payment'
             && share.lastUrl !== '/about' && share.lastUrl !== '/game' && share.lastUrl !=='order/TableId/' && share.lastUrl !=='/portal' && share.loginuser?.tasfie === 'SEPIDZSETTING' "
                (click)="exampleSidenav.close(); go('portal')">
                <i class="icon-dashboard-o1 sideicon dashboardicon"></i>
                <span class="text"> {{'MainPage.Portal' | translate}} </span>
            </button>
            <mat-divider></mat-divider>
            <button class="list-btn" mat-button
                *ngIf="share.lastUrl !== '/login'
            && share.lastUrl !== '/finalfactor'&& share.lastUrl !== 'club' && share.lastUrl !== 'payment'
             && share.lastUrl !== '/about' && share.lastUrl !== '/game' && share.lastUrl !=='order/TableId/' && share.lastUrl !=='/setting' && share.loginuser?.tasfie === 'SEPIDZSETTING' "
                (click)="exampleSidenav.close(); go('pay-setting')">
                <i class="icon-settings-o1 sideicon settingicon"></i>
                <span class="text"> {{'MainPage.setting' | translate}} </span>
            </button>
            <mat-divider></mat-divider>
            <button class="list-btn" mat-button *ngIf="share.lastUrl !== '/login'
       && share.lastUrl !== '/finalfactor'&& share.lastUrl !== 'club' && share.lastUrl !== 'payment'
        && share.lastUrl !== '/about' && share.lastUrl !== '/game' && share.lastUrl !=='order/TableId/' "
                (click)="exampleSidenav.close(); exit()">
                <i class="icon-exit_to_app-o sideicon exittoapp"></i>
                <span class="text"> {{'Public.Exit' | translate}} </span>
            </button>
            <mat-divider></mat-divider>

        </mat-nav-list>
        <div class="footer text">www.SEPIDZ.com 2.1.0907.1</div>
    </mat-sidenav>
</div>
